import estyled from '@signal/theme/emotion'
import MenuItem from '@material-ui/core/MenuItem'

export const CustomMenuItem = estyled<typeof MenuItem.prototype>(MenuItem)`
  && {
    padding: 3px 6px;
    &:hover,
    &.Mui-selected,
    &.Mui-focusVisible {
      background-color: transparent !important;
    }
  }
`
